// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pn-5";
export var filledCircle = "_pn-4";
export var historyEntry = "_pn-3";
export var messageSideLeft = "_pn-1";
export var messageSideRight = "_pn-2";
export var orderTrackingCarouselWrapper = "_pn-6";
export var orderTrackingInfoContainer = "_pn-0";